// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  soa_authorization: '',
  lightbox_src:'',
  lightbox_data_account:'',
  lightbox_data_mode:'',
  lightbox_data_amount:'',
  version:'1.0.2'
};

export const environmentLoader = new Promise<any>((resolve, reject) => {
  var xmlhttp = new XMLHttpRequest(),
    method = 'GET',
    url = './assets/environments/environment.json';
    xmlhttp.open(method, url, true);
    xmlhttp.onload = function() {
      if (xmlhttp.status === 200) {
        resolve(JSON.parse(xmlhttp.responseText));
        console.log(environment);
      } else {
        resolve(environment);
      }
    };
  xmlhttp.send();
});
